import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AtribuicaoEtapaConfigService from "../../services/resource/atribuicaoEtapaConfigService";
import UsuarioService from "../../services/resource/usuarioService";
import GrupoService from "../../services/resource/grupoService";

const service = new AtribuicaoEtapaConfigService();
const usuarioService = new UsuarioService();
const grupoService = new GrupoService();

export function useAtribuicoesConfig() {
    const [configs, setConfigs] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const carregar = useCallback(() => {
        setLoading(true);
        service.listar()
            .then(res => setConfigs(res.data))
            .catch(error => {
                console.error("Erro ao listar configurações de atribuição", error);
                toast.error("Erro ao carregar configurações de atribuição");
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
        usuarioService.listarUsuarios().then(res => setUsuarios(res.data)).catch(() => setUsuarios([]));
        grupoService.listarGrupos().then(res => setGrupos(res.data)).catch(() => setGrupos([]));
    }, [carregar]);

    function salvar(id, dados) {
        setSaving(true);
        const requisicao = id ? service.atualizar(id, dados) : service.cadastrar(dados);
        return requisicao
            .then(() => {
                toast.success(id ? "Atribuição atualizada com sucesso!" : "Atribuição cadastrada com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao salvar atribuição", error);
                toast.error("Erro ao salvar atribuição");
                throw error;
            })
            .finally(() => setSaving(false));
    }

    function excluir(id) {
        return service.excluir(id)
            .then(() => {
                toast.success("Atribuição excluída com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao excluir atribuição", error);
                toast.error("Erro ao excluir atribuição");
                throw error;
            });
    }

    return { configs, usuarios, grupos, loading, saving, recarregar: carregar, salvar, excluir };
}
